import { render } from "./MicrositeFooter.vue?vue&type=template&id=24bb9708"
import script from "./MicrositeFooter.vue?vue&type=script&lang=js"
export * from "./MicrositeFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__